import _ from "underscore";

type NullableNumberString = number | string | undefined;

export class Functions {
	static isNullOrEmpty(value): boolean {
		if (value === null) {
			return true;
		}
		if (value instanceof Array) {
			return value.length === 0;
		}
		return value.toString().trim() === "";
	}

	/**
	 * Método que retira letras e caracteres especiais e retorna apenas dígitos
	 * @param dado valor que será formatado
	 */
	static removerFormatacao(dado): string {
		if (dado && dado.toString().length > 0) {
			dado = dado.toString().replace(/[\D]*/g, "");
			return dado;
		}
		return "";
	}
	static formatMoeda(value): string {
		return `R$ ${Functions.masckMoney(value)}`;
	}
	static formatDecimal(value): string {
		return `${Functions.masckMoney(value)}`;
	}
	static download(url: string, download: string): void {
		const link = document.createElement("a");
		link.download = download;
		link.href = url;
		link.click();
		link.remove();
	}

	static fitlerItemDescricaoValue = (valores, sigla): string => {
		if (valores && valores.length > 0) {
			const aux = valores.filter((e) => e.sigla.includes(Functions.Trim(sigla)));
			if (aux && aux.length > 0) {
				return aux[0].descricao;
			}
		}
		return "";
	};

	static masckMoney(value): string {
		let v = `${value}`;
		v = v.replace(/\D/g, "");
		v = `${parseFloat(v)}`;
		const len = v.length;
		if (1 === len) v = v.replace(/(\d)/, "0,0$1");
		else if (2 === len) v = v.replace(/(\d)/, "0,$1");
		else if (len > 2) {
			v = v.replace(/(\d{2})$/, ",$1");
		}
		return v;
	}

	static masckMoney2(value): number {
		let v = `${value}`;
		v = v.replace(/\D/g, "");
		v = `${parseFloat(v)}`;
		const len = v.length;
		if (1 === len) v = v.replace(/(\d)/, "0.0$1");
		else if (2 === len) v = v.replace(/(\d)/, "0.$1");
		else if (len > 2) {
			v = v.replace(/(\d{2})$/, ".$1");
		}
		return parseFloat(v);
	}

	static numberToRealCurrencyFormat(value: NullableNumberString): string {
		const valueNumber = Number(value);
		if (typeof valueNumber === "number" && !isNaN(valueNumber)) {
			const newValue = valueNumber.toFixed(2).split(".");
			newValue[0] = newValue[0].split(/(?=(?:...)*$)/).join(".");
			return newValue.join(",");
		} else {
			return "0,00";
		}
	}

	static numberToRealCurrencyFormatOrEmpty(value: NullableNumberString): string | null | undefined {
		if (value === "") return "";
	
		const valueNumber = Number(value);
	
		if (typeof valueNumber === "number" && !isNaN(valueNumber)) {
			const sign = valueNumber < 0 ? "-" : ""; 
			const absoluteValue = Math.abs(valueNumber);
	
			const newValue = absoluteValue.toFixed(2).split(".");
			newValue[0] = newValue[0].split(/(?=(?:...)*$)/).join(".");
			return sign + newValue.join(",");
		} else {
			return "";
		}
	}

	static numberToRealCurrencyFormatOrEmptyRefactory(value: NullableNumberString): string | null | undefined {
		if (value === "") return "";
	 
		const valueNumber = Number(value);
	 
		if (typeof valueNumber === "number" && !isNaN(valueNumber)) {
		    return valueNumber.toLocaleString("pt-BR", { maximumFractionDigits: 0 });
		} else {
		    return "";
		}
	 }
	 
	
	static numberToMoney(value: number | undefined): string {
		if (value) {
			const newValue = value.toFixed(2).split(".");
			newValue[0] = newValue[0].split(/(?=(?:...)*$)/).join(".");
			return newValue.join(",");
		} else {
			return "0,00";
		}
	}

	
	static numberToDecimalPtBrFormat(value: number | undefined): string {
		if (value) {
			const newValue = value.toString().split(".");
			return newValue.join(",");
		} else {
			return "0,00";
		}
	}

	static numberDecimal(value: string): number {
		const newvalue = this.removerFormatacao(value);
		return parseFloat(newvalue) / 100;
	}

	static parseBoolean(value: string | boolean): boolean {
		if (value && value !== null && "false" !== value) {
			return true;
		}
		return false;
	}

	static maskCEP(v: string): string {
		if (v) {
			return v.substring(0, 2) + "." + v.substring(2, 5) + "-" + v.substring(5);
		} else {
			return " ";
		}
	}

	static inArray(value, array): boolean {
		return array.indexOf(value) !== -1;
	}

	static obterCaracteristicaLaudo = (laudo): string => {
		let caracteristica = " ";
		if (laudo) {
			caracteristica = laudo.descTipoCaracteristica === laudo.descTipoLaudo ? caracteristica : laudo.descTipoCaracteristica;
		}
		return caracteristica;
	};

	static verificarLaudoImovelUrbano = (laudo): boolean => {
		const listaTipo = ["Terreno Urbano", "Construção Urbana", "Especial Urbano"];
		const caracteristica = Functions.obterCaracteristicaLaudo(laudo);
		return Functions.inArray(caracteristica, listaTipo) && laudo.descTipoLaudo === "Avaliação de Imóveis";
	};

	static maskCapitalSocial(v: string): string {
		if (v) {
			let s;
			if (v.length > 2) {
				s = v.substring(0, 2) + "," + v.substring(2);
				return s;
			} else {
				return v;
			}
		} else {
			return "";
		}
	}
	static maskCpfCnpj = (value) => {
		if (value === undefined || value === null) {
			return "";
		}
		const newValue = value.toString().replace(/\D/g, "");
		if (newValue > 0 && newValue.length <= 11) {
			return Functions.formatCpf(Functions.zeroLeft(newValue, 11));
		}
		if (newValue > 0 && newValue.length <= 14) {
			return Functions.formatCpnj(Functions.zeroLeft(newValue, 14));
		}
		return newValue;
	};
	static maskCpf = (value) => {
		if (value === undefined || value === null) {
			return "";
		}
		const newValue = value.toString().replace(/\D/g, "");
		if (newValue > 0 && newValue.length <= 11) {
			return Functions.formatCpf(Functions.zeroLeft(newValue, 11));
		}
		return newValue;
	};

	static maskCnpj = (value) => {
		if (value === undefined || value === null) {
			return "";
		}
		const newValue = value.toString().replace(/\D/g, "");
		if (newValue > 0 && newValue.length <= 14) {
			return Functions.formatCpnj(Functions.zeroLeft(newValue, 14));
		}
		return newValue;
	};
	static formatCpf = (value) => {
		const newValue = value.replace(/\D/g, "");
		return newValue
			.replace(/\D/g, "") // substitui qualquer caracter que nao seja numero por nada
			.replace(/(\d{3})(\d)/, "$1.$2") // captura 2 grupos de nro o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de nro
			.replace(/(\d{3})(\d)/, "$1.$2")
			.replace(/(\d{3})(\d{1,2})/, "$1-$2")
			.replace(/(-\d{2})\d+?$/, "$1"); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
	};

	static formatCpnj = (value) => {
		return value
			.toString()
			.replace(/\D/g, "") // substitui qualquer caracter que nao seja numero por nada
			.replace(/(\d{2})(\d)/, "$1.$2") // captura 2 grupos de nro o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de nro
			.replace(/(\d{3})(\d)/, "$1.$2")
			.replace(/(\d{3})(\d)/, "$1/$2")
			.replace(/(\d{4})(\d{1,2})/, "$1-$2")
			.replace(/(-\d{2})\d+?$/, "$1"); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
	};

	static removeMask(value: string): string {
		if (!value) return "";
		return value.toString().replace(/[^0-9]+/g, "");
	}
	static realToNumber(moeda): number {
		if (!moeda) return 0;
		let value = moeda.replace("R$", "");
		value = value.replace(".", "");
		value = value.replace(",", ".");
		return parseFloat(value);
	}
	static zeroLeft(number, length): string {
		let retorno = `${number}`;
		while (retorno.length < length) {
			retorno = `0${retorno}`;
		}
		return retorno;
	}

	static validarFone(valor: string): boolean {
		valor = this.removeMask(valor);
		return valor.length >= 10;
	}

	/**@name clearDot
	 * @description retira até 5 pontos do texto passado
	 * @param text(string)
	 */
	static clearDot(text: string): string {
		let treat = text;

		treat = treat.replace(".", "");
		treat = treat.replace(".", "");
		treat = treat.replace(".", "");
		treat = treat.replace(".", "");
		treat = treat.replace(".", "");

		return treat;
	}

	static maskFone(value: string): string {
		if (!value) return "";
		if (value.length > 10) {
			return value.replace(/^(\d{2})(\d{5})(\d{4})+$/, "($1) $2-$3");
		} else if (value.length === 10) {
			return value.replace(/^(\d{2})(\d{4})(\d{4})+$/, "($1) $2-$3");
		} else if (value.length === 9) {
			return value.replace(/^(\d{5})(\d{4})+$/, "$1-$2");
		} else {
			return value.replace(/^(\d{4})(\d{4})+$/, "$1-$2");
		}
	}

	static maskLatitude(value: string | null): string {
		if (!value) return "";

		const state = "124419";

		let degree = state.slice(0, 2),
			minute = state.slice(2, 4),
			second = state.slice(4, 6);

		if (degree) degree += "°";
		if (minute) minute += "'";
		if (second) second += '"';

		return [degree, minute, second].join(" ");
	}

	static convertInt(value: NullableNumberString, valueIfUndefined: NullableNumberString = 0): number | string {
		try {
			if (value) {
				return Number.parseInt(value.toString());
			}
		} catch {
			return valueIfUndefined;
		}
		return valueIfUndefined;
	}

	static convertFloat(value: NullableNumberString, valueIfUndefined: NullableNumberString  = 0): number | string {
		try {
			if (value) {
				return parseFloat(value.toString());
			}
		} catch {
			return valueIfUndefined;
		}
		return valueIfUndefined;
	}

	static convertDecimal(value: NullableNumberString, valueIfUndefined: NullableNumberString = 0): number | string {
		try {
			if (value) {
				return parseFloat(value.toString()) / 100;
			}
		} catch {
			return valueIfUndefined;
		}
		return valueIfUndefined;
	}

	static isNotBlank(value): boolean {
		return value !== undefined && value !== null && value !== "";
	}

	/*  Substitui o if ternário nos componentes  - com dois parâmetros: quando UM dos retornos é a própria condição */
	static verificarPropriedade(dado: any, tipoRetorno: any) {
		if (dado) {
			return dado;
		} else {
			return tipoRetorno;
		}
	}

	/*  Substitui o if ternário nos componentes  - com dois parâmetros: quando UM dos retornos é a própria condição */
	static verificarCritica(campo: string, critica: string | undefined) {
		return campo === critica;
	}

	/*  Substitui o if ternário nos componentes - com três parâmetros: quando nenhum dos retornos é a própria condição */
	static verificarPropriedadeBoolean = (dado: any, retornoTrue: any, retornoFalse: any) => {
		if (dado) {
			return retornoTrue;
		} else {
			return retornoFalse;
		}
	};

	static isBlank(value): boolean {
		return !Functions.isNotBlank(value);
	}
	
	static isNumberPositiveNonZero(value): boolean {
		const intValue = Functions.convertInt(value);
		return this.isNotBlank(value) && typeof intValue === "number" && intValue > 0;
	}

	static compareObjects(objectA, objectB): boolean {
		return _.isEqual(objectA, objectB);
	}

	static removerUltimoDigito(num: number): number {
		const str = num ? num.toString() : "0";
		return Number.parseInt(str.substr(0, str.length - 1));
	}
	static numberFormatSicadOrCpfOrCnpj(value: string): string {
		if (!value) return "";
		value = value.replace(/\D/g, "");
		if (value.length === 11) {
			return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
		} else if (value.length === 14) {
			return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
		} else {
			return value;
		}
	}

	static intersect(a: any[], b: any[]): any[] {
		let t;
		if (b.length > a.length) {
			t = a;
			a = b;
			b = t;
		}
		return a.filter((e) => {
			return b.indexOf(e) > -1;
		});
	}

	static filter(a: any[], query: string, field: { key: string }): any {
		return a.filter((i) => (i[field.key] as string).includes(query));
	}

	static Trim(strTexto: string | undefined): string {
		if (strTexto) {
			return strTexto.trim().replace(/^s+|s+$/g, "");
		}
		return "";
	}

	static convertCoordenadasDecimaisToGraus(decimais: string): string {
		if (decimais) {
			const coords: any[] = decimais.split(",");
			
			const graus1 = Math.floor(Math.abs(coords[0]));
			if (graus1 > 90.99999) {
				return "";
			}
			let minutos1 = (Math.abs(coords[0]) - graus1) * 60;
			const segundos1 = ((minutos1 - Math.floor(minutos1)) * 60).toFixed(4);
			minutos1 = Math.floor(minutos1);
			const coord1 = graus1 + "° " + minutos1 + "' " + segundos1 + "'' ";
			const norteSul = coords[0] < 0 ? "S " : "N ";



			if (coords[1]) {
				const graus2 = Math.floor(Math.abs(coords[1]));
				if (graus2 > 180.99999) {
					return "";
				}
				let minutos2 = (Math.abs(coords[1]) - graus2) * 60;
				const segundos2 = ((minutos2 - Math.floor(minutos2)) * 60).toFixed(4);
				minutos2 = Math.floor(minutos2);
				const coord2 = graus2 + "° " + minutos2 + "' " + segundos2 + "''";

				const lesteOeste = coords[1] < 0 ? "W " : "E ";

				return norteSul + coord1 + " | " + lesteOeste + coord2;
			} else {
				return norteSul + coord1 + " | ";
				
			}
			
		}
		return "";
	}

	static convertCoordenadasGrausToDecimal(graus: string): string {
		if (graus && graus.length >= 3) {
			const coords: any[] = graus.split("|");
			let coord: string[] = coords[0].split(" ");
			const grau1: number = coord[1] ? Number.parseInt(coord[1].replace("°", "")) : 0;
			const minuto1: number = coord[2] ? Number.parseFloat(coord[2].replace("'", "")) / 60 : 0;
			const segundo1: number = coord[3] ? Number.parseFloat(coord[3].replace("''", "")) / 3600 : 0;

			let coord1 = grau1 + minuto1 + segundo1;

			coord1 = coord[0].charAt(0) === "S" ? coord1 * -1 : coord1;
			if (coords[1] && coords[1].length >= 4) {
				coord = coords[1].substring(1).split(" ");
				const grau2: number = coord[1] ? Number.parseInt(coord[1].replace("°", "")) : 0;
				const minuto2: number = coord[2] ? Number.parseFloat(coord[2].replace("'", "")) / 60 : 0;
				const segundo2: number = coord[3] ? Number.parseFloat(coord[3].replace("''", "")) / 3600 : 0;
				let coord2 = grau2 + minuto2 + segundo2;
				coord2 = coord[0].charAt(0) === "W" ? coord2 * -1 : coord2;
				return coord1.toFixed(6) + ", " + coord2.toFixed(6);
			}

			return coord1.toFixed(4).toString();
		}
		return "";
	}

	static isEquivalent(a, b): boolean {
		// Create arrays of property names
		const aProps = Object.getOwnPropertyNames(a);
		const bProps = Object.getOwnPropertyNames(b);

		// If number of properties is different,
		// objects are not equivalent
		if (aProps.length !== bProps.length) {
			return false;
		}

		for (const propName of aProps) {
			// If values of same property are not equal,
			// objects are not equivalent
			if (a[propName] !== b[propName]) {
				return false;
			}
		}

		// If we made it this far, objects
		// are considered equivalent
		return true;
	}

	static isEquivalentById(a, b): boolean {
		// Create arrays of property names
		const aProps = Object.getOwnPropertyNames(a);
		const bProps = Object.getOwnPropertyNames(b);

		// If number of properties is different,
		// objects are not equivalent
		if (aProps.length !== bProps.length) {
			return false;
		}

		if (aProps["id"] && aProps["id"] !== bProps["id"]) {
			return false;
		}

		if (aProps["codigo"] && aProps["codigo"] !== bProps["codigo"]) {
			return false;
		}

		// If we made it this far, objects
		// are considered equivalent
		return true;
	}

	static formatInteger = (value ? : string | number): string => {
		if (value !== undefined) {
			let newValue;
			if (typeof value === 'number') {
				newValue = value.toString();
			} else {
				newValue = value;
			}
			newValue = newValue.replace(/\D/g, "");
			newValue = newValue.replace(/(\d)(?=(\d{3})+(?!\d)+(?!\d)+(?!\d))/g, "$1.");
			return newValue;
		} else {
			return "";
		}
	}
  

	static somenteDigitos = (str) => {
		return str.replace(/\D/g, "");
	}



	static converterParaNumero = (valor) => {

		if (!valor || valor === null) {
			return 0;
		}

		if (typeof valor === 'number') {
		  return valor; 
		}
	  
		if (typeof valor === 'string') {
		  // Remover pontos de milhar e substituir vírgula por ponto para formar um número válido
		  const valorNumerico = Number(valor.replace(/\./g, '').replace(',', '.'));
	  
		  // Verificar se a conversão foi bem-sucedida
		  if (!isNaN(valorNumerico)) {
			return valorNumerico;
		  }
		}
	  
		// Se não for possível converter, retornar null ou lançar uma exceção, dependendo do caso
		return 0;
	  }	
	
	
}
